import storage from './storage';

export const setTripStorageId = trip => storage.setItem('userTrip', trip);

export const getTripId = () => storage.getItem('userTrip');

export const removeTripId = () => storage.removeItem('userTrip');
